<template>
  <v-container>
    <v-container class="ma-0 pa-0 d-flex">
      <h1>Актуальность данных</h1>
    </v-container>

    <v-container class="ma-0 pa-0 mt-2">
      <v-data-table
        :items="$store.state.sites.actualData"
        :loading="loadingActualData"
        :headers="tblHeaders"
        item-key="_id"
        class="elevation-1"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`item.site`]="{item}">
          <a :href="item.url" target="_blank">{{item.name}}</a>
          <div style="font-size: 11px;">
            {{item.curRentDeal.partner.fullName}}<br>
            {{item.curRentDeal.partner.email}}<br>
            <template v-if="item.curRentDeal.partner.partnerCV.phoneNumber">
              +7{{item.curRentDeal.partner.partnerCV.phoneNumber}}
            </template>
          </div>
        </template>

        <template v-slot:[`item.actual.СОТР`]="{item}">
          <v-chip :color="item.actual.СОТР ? 'green' : 'red'"></v-chip>
        </template>
        <template v-slot:[`item.actual.ОТЗЫВ`]="{item}">
          <v-chip :color="item.actual.ОТЗЫВ ? 'green' : 'red'"></v-chip>
        </template>
        <template v-slot:[`item.actual.ПОРТФ`]="{item}">
          <v-chip :color="item.actual.ПОРТФ ? 'green' : 'red'"></v-chip>
        </template>
        <template v-slot:[`item.actual.БОНУС`]="{item}">
          <v-chip :color="item.actual.БОНУС ? 'green' : 'red'"></v-chip>
        </template>
        <template v-slot:[`item.actual.ОБЩИЕ`]="{item}">
          <v-chip :color="item.actual.ОБЩИЕ ? 'green' : 'red'"></v-chip>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      tblHeaders: [
        {
          text: 'Сайт (Партнер)',
          value: 'site'
        },
        {
          text: 'СОТР',
          value: 'actual.СОТР'
        },
        {
          text: 'ОТЗЫВ',
          value: 'actual.ОТЗЫВ'
        },
        {
          text: 'ПОРТФ',
          value: 'actual.ПОРТФ'
        },
        {
          text: 'БОНУС',
          value: 'actual.БОНУС'
        },
        {
          text: 'ОБЩИЕ',
          value: 'actual.ОБЩИЕ'
        },
        
      ]
    }
  },

  created() {
    this.$store.dispatch('sites/loadActualData');
  },
  
  computed: {
    ...mapGetters('sites', ['loadingActualData'])
  }
}
</script>